import type { Endpoint, Request, RequestArgs, Route } from '../types.no-deps'
import type { UUID } from '../../../shared/lib/typeHelpers.no-deps'
import type * as Posts from '../../../shared/domain/posts/types.no-deps'

export const route: Route = { method: 'GET', pattern: '/api/posts/ordering' }

type Params = never
type Body = never
type Query = (Posts.LocationTarget | Posts.ProcedureTarget | Posts.UnitTarget) & {
    sortBy?: Posts.PostsSortBy
    filterByText?: string
    sinceDate?: Date
    tillDate?: Date
    filterByEventTypes?: Posts.EventTypeFilterOptions | Posts.EventTypeFilterOptions[]
    filterByCollaboratorUsers?: number | number[]
    filterByCollaboratorTeams?: number | number[]
    pageSize?: number
    startAfterId?: UUID
    excludeFiles?: boolean
}
type Output = { posts: UUID[] }

export type GetOrderEndpoint = Endpoint<Params, Body, Query, Output>

export const getOrderRequest = (request: Request, args: RequestArgs<GetOrderEndpoint>) =>
    request<GetOrderEndpoint>(route, args)
